// extracted by mini-css-extract-plugin
export default {"switchBaseStyle":"Switch_switchBaseStyle__+dXG-"};